/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchEndpointRequest
 */
export interface SearchEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchEndpointRequest
     */
    query: string;
    /**
     * 
     * @type {string}
     * @memberof SearchEndpointRequest
     */
    exclude?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchEndpointRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchEndpointRequest
     */
    limit?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SearchEndpointRequest
     */
    dirsOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchEndpointRequest
     */
    namesOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchEndpointRequest
     */
    tapes?: boolean;
}

export function SearchEndpointRequestFromJSON(json: any): SearchEndpointRequest {
    return SearchEndpointRequestFromJSONTyped(json, false);
}

export function SearchEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'query': json['query'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'dirsOnly': !exists(json, 'dirs_only') ? undefined : json['dirs_only'],
        'namesOnly': !exists(json, 'names_only') ? undefined : json['names_only'],
        'tapes': !exists(json, 'tapes') ? undefined : json['tapes'],
    };
}

export function SearchEndpointRequestToJSON(value?: SearchEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'query': value.query,
        'exclude': value.exclude,
        'offset': value.offset,
        'limit': value.limit,
        'dirs_only': value.dirsOnly,
        'names_only': value.namesOnly,
        'tapes': value.tapes,
    };
}


